import Handlebars from 'handlebars';
import EventHub from '~/eventHub';
import previsual_template from '~/templates/previsual.handlebars';
import GeneralView from '~/generalView';

const IMAGE_FILE_EXT = ["jpg", "jpeg", "jfif", "pjpeg", "pjp", "apng", "avif", "gif", "png", "svg", "webp"];

const AUDIO_MIME_TYPES = {
  "3gp":"3gpp", "aac":"aac", "flac":"flac", "mpg":"mpeg", "mpeg":"mpeg", "mp3":"mp3", "mp4":"mp4", "m4a":"mp4",
  "oga":"ogg", "ogg":"ogg", "wav":"wav", "webm":"webm"
};
const VIDEO_MIME_TYPES = {
  "3gp":"3gpp", "mpg":"mpeg", "mpeg":"mpeg", "mp4":"mp4", "m4v":"mp4", "m4p":"mp4", "mov":"quicktime",
  "ogv":"ogg", "ogg":"ogg", "webm":"webm"
};

Handlebars.registerHelper('isImage', function (value) {
  return IMAGE_FILE_EXT.includes(value);
});

Handlebars.registerHelper('isVideo', function (value) {
  return VIDEO_MIME_TYPES[value] !== undefined;
});

Handlebars.registerHelper('isAudio', function (value) {
  return AUDIO_MIME_TYPES[value] !== undefined;
});

var PrevisualView = GeneralView.View.extend({
    tagName: "div",
    className: 'previsual',
	fileURL: "",
	name: "",
    events: {
		"click .download-file" : "download",
    },

	initialize: function(options) {
		this.options = options;
		_.bindAll(this, 'render');
	},
	
	download: async function () {
		$("#preview-spinner").show();
		const response = await fetch(this.fileURL+"?crossorigin");
		const blob = await response.blob();
	
		const link = document.createElement("a");
		link.href = URL.createObjectURL(blob);
		link.download = this.name;
		link.click();
		$("#preview-spinner").hide();
	},

	render: function () {
		var handlebarsTemplate = Handlebars.template(previsual_template);
		this.fileURL = this.options.file;
		this.name = this.options.title;
		var re = /(?:\.([^.]+))?$/;
		var ext = re.exec(this.options.file.toLowerCase())[1];
		var mime = undefined;
		if(AUDIO_MIME_TYPES[ext] !== undefined){
			mime = "audio/"+AUDIO_MIME_TYPES[ext];
		}
		if(VIDEO_MIME_TYPES[ext] !== undefined){
			mime = "video/"+VIDEO_MIME_TYPES[ext];
		} 
		this.$el.html(handlebarsTemplate({
			file: this.options.file, title: this.options.title, ext: ext, mime: mime
		}));
		this.$el.find('#previsual-modal').modal('show');
		this.$el.find("#previsual-modal").on("hidden.bs.modal", () => {
			this.$el.find('.modal-body').empty();
		});
		$('.modal').on('hidden.bs.modal', function (e) {
			if($('.modal').hasClass('in')) {
				$('body').addClass('modal-open');
			}   
		});
	},
});
export default PrevisualView;
